//#region src/js/lang-form.js
var LocalizationForm = class extends HTMLElement {
	connectedCallback() {
		if (this.initialized) return;
		this.initialized = true;
		this.elements = {
			input: this.querySelector("input[name=\"locale_code\"], input[name=\"country_code\"]"),
			button: this.querySelector("[data-lang-button]"),
			panel: this.querySelector("[data-lang-list]")
		};
		this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
		this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
	}
	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;
		if (this.elements.button.getAttribute("aria-expanded") === "false") return;
		this.hidePanel();
		event.stopPropagation();
		this.elements.button.focus();
	}
	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector("form");
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}
};
if (!customElements.get("localization-form")) customElements.define("localization-form", LocalizationForm);
//#endregion
